import React from 'react'
import { Link } from 'react-router-dom'
import { useAppContext } from '../context/AppContext';
import logo from "../assets/logo.svg"
import toast from "react-hot-toast"

const Navbar = () => {

    const { axios, token, setToken, navigate } = useAppContext();

    const logOutHandler = () => {
        toast.success("Logout Successful");
        localStorage.removeItem('token');
        axios.defaults.headers.common['Authorization'] = null;
        setToken(null);
        navigate('/');
    }

    return (
        <div className="flex justify-between items-center py-5 mx-8 sm:mx-20 xl:mx-32">
            <img
                onClick={() => navigate("/")}
                src={logo}
                alt="Logo"
                className="w-32 sm:w-44 cursor-pointer"
            />
            <div className="flex gap-4">
                {
                    !token &&
                    <Link to="/login">
                        <button className="flex items-center gap-2 rounded-full text-sm cursor-pointer bg-primary text-white px-10 py-2.5">
                            Login
                        </button>
                    </Link>
                }
                {
                    !token &&
                    <Link to="/signup">
                        <button className="flex items-center gap-2 rounded-full text-sm cursor-pointer bg-primary text-white px-10 py-2.5">
                            Signup
                        </button>
                    </Link>
                }
                {
                    token &&
                    <Link to="/dashboard">
                        <button className="flex items-center gap-2 rounded-full text-sm cursor-pointer bg-primary text-white px-10 py-2.5">
                            Dashboard
                        </button>
                    </Link>
                }
                {
                    token &&
                    <Link to="/">
                        <button className="flex items-center gap-2 rounded-full text-sm cursor-pointer bg-primary text-white px-10 py-2.5" onClick={logOutHandler}>
                            Logout
                        </button>
                    </Link>
                }

            </div>
        </div>
    )
}

export default Navbar